export const updateResource = (payload, {setStatus, setSubmitting, setErrors}, resource, setLoading, handleUpdate) => {
    setLoading(true);
    setStatus('');
    resource.update(payload)
        .then(({data: {message, data}}) => {
            setLoading(false);
            setStatus(message);
            setSubmitting(false);
            handleUpdate(payload);
        })
        .catch((error) => {
            const {response: {data: {errors = [], message = ""} = {}}} = error;
            setErrors(errors);
            setLoading(false);
            setSubmitting(false);
            setStatus(message || "Failed: An error occurred");
        });
};

export const createResource = (payload, {setStatus, setSubmitting, setErrors, resetForm}, resource, setLoading, handleCreate) => {
    setLoading(true);
    setStatus('');
    resource.create(payload)
        .then(({data: {message, data}}) => {
            setLoading(false);
            resetForm();
            setStatus(message);
            handleCreate(data);
        })
        .catch((error) => {
            const {response: {data: {errors = [], message = ""} = {}}} = error;
            setErrors(errors);
            setLoading(false);
            setSubmitting(false);
            setStatus(message || "Failed: An error occurred");
        });
};